import { useEffect, useState } from "react";
import {
  Button,
  Image,
} from "react-bootstrap";
import facebook_icon from "../../assests/images/blog-page-images/white-facebook.svg"
import NoImage from "../../assests/images/gnp_noimg.png";
import Logo from '../../assests/images/gnp_logo.svg';
import {
  ConfirmationCard,
  Divider,
  DonationConfirmSection,
  DonationConfirmWrapper,
  H2,
  NonprofitLink,
  NonprofitListItem,
  ShareOnFacebook,
  Title,
  LogoWrapper,
} from "./donationConfirmStyle";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { donatedNonprofitsHandler } from "../../redux/slices/donationCamp/donateTo-slice";
import MetaComponent from "../../components/common/metaComponent";

const DonationConfirmation = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const [searchParams] = useSearchParams()
  const payment_id = searchParams.get("pid")
  const donations = useSelector((state: any) => state.donateTo?.donations?.results || []);
  const [userId, setUserId] = useState<string | null>(null);
  useEffect(() => {
    if (payment_id) { dispatch(donatedNonprofitsHandler(payment_id) as any) }
  }, [payment_id])
  // const user_id = typeof localStorage !== "undefined" && localStorage.getItem("userId");
  useEffect(() => {
    if (typeof window !== "undefined") {
      const user_id = localStorage.getItem("userId");
      setUserId(user_id);
    }
  }, []);
  return (
    <>
      <MetaComponent
        keywords="nonprofits, non-profits, not for profits, volunteer, donate, donation, volunteering, ratings, rate, best non-profits, best nonprofits, best charities, top nonprofits, top charities, top non-profits, charitable giving, giving to nonprofits"
        description="Find and review charities, nonprofits and volunteering and donation opportunities. Want to donate or volunteer? Find the best non-profit or charity"
        ogTitle="Donations Confirm"
        ogDescription="Find and review charities, nonprofits and volunteering and donation opportunities. Want to donate or volunteer? Find the best non-profit or charity"
        ogUrl="https://qa.greatnonprofits.org/donations/confirmation/?pid=63K07487CY8510739"
        ogImage="https://devcdn.greatnonprofits.org/img/gnp-facebook-share-lg.png"
      />
      <DonationConfirmSection>
        <DonationConfirmWrapper>
          <LogoWrapper><Image src={Logo} alt="logo" width="316px" height="24px" /></LogoWrapper>
          <Title>Thank You!</Title>
          <Title>You are making a diffrence</Title>
          <ConfirmationCard>
            <p>
              Thank you for your generosity! <br />
              Check your email for your donation confirmation and receipt.
            </p>
          </ConfirmationCard>
          <H2><strong>Every 2 shares can lead to a new donation!</strong></H2>
          {/* <ShareOnFacebook>
            {donations?.map((item: any, i: number) => <Button key={i + 1} href={`https://www.facebook.com/sharer/sharer.php?u=${import.meta.env.VITE_WEBSITE_URL}/org/${item?.slug}`} target="_blank">
              <Image src={facebook_icon} alt="google icon" width="" height="" /> <span>Share on Facebook</span>
            </Button>)}
          </ShareOnFacebook> */}
          {donations.length > 0 && (
            <ShareOnFacebook>
              <Button
                href={`https://www.facebook.com/sharer/sharer.php?u=${import.meta.env.VITE_WEBSITE_URL}/org/${donations[0]?.slug}`}
                target="_blank"
              >
                <Image src={facebook_icon} alt="facebook icon" width="" height="" style={{ marginRight: '8px' }} />
                <span>Share on Facebook</span>
              </Button>
            </ShareOnFacebook>
          )}

          <Divider />
          {donations?.map((item: any, i: number) => <NonprofitListItem key={i + 1}>
            <NonprofitLink><Image src={item?.logo || NoImage} alt="Nonprofit Logo" style={{ maxWidth: "100px", maxHeight: "100px" }} /> <Link to={`/org/${item?.slug}`}>{item?.title}</Link></NonprofitLink>
            {/* {user_id && <Button onClick={() => { navigate(`/write-review/${item?.id}`, { state: { title: item?.title } }) }} >Share your story</Button>} */}
            {userId && <Button onClick={() => { navigate(`/write-review/${item?.id}`, { state: { title: item?.title } }) }} >Share your story</Button>}
          </NonprofitListItem>)}
        </DonationConfirmWrapper>
      </DonationConfirmSection>
    </>

  );
};

export default DonationConfirmation;
